import { styleButtonBlue, styleButtonOrange, styleButtonGray } from "./style";

/**
 * @param {String} text Text inside button
 * @param {String} type (blue - blue button / orange - orange button)
 * @param {Function} functionBtn Function when button is clicked
 * @returns Button with style blue or orange
 */
const ButtonCustom = ({ text, type, functionBtn }) => {
  return (
    <button
      type="button"
      onClick={() => functionBtn()}
      style={
        type === "blue"
          ? styleButtonBlue.container
          : type === "gray"
          ? styleButtonGray.container
          : styleButtonOrange.container
      }
    >
      {text}
    </button>
  );
};

export default ButtonCustom;
